import { render, staticRenderFns } from "./CurriculumRegime.vue?vue&type=template&id=6d7a34bc"
import script from "./CurriculumRegime.vue?vue&type=script&lang=js"
export * from "./CurriculumRegime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports